import React from 'react';
import classnames from 'classnames';

const BoxPreview = ({checkActivated, handleClickToggle}) => {
  const positions = [
    {
      keyword: 'list_upper',
      label: <span className="txt_g">목록 상단</span>,
      className: 'pos_top',
    },
    {
      keyword: 'list_lower',
      label: <span className="txt_g">목록 하단</span>,
      className: 'pos_bot',
    },
    {
      keyword: 'sidebar',
      label: <span className="txt_g">사이드바</span>,
      className: 'pos_sidebar',
    },
    {
      keyword: 'content_upper',
      label: <span className="txt_g">본문 상단</span>,
      className: 'pos_cont_top',
    },
    {
      keyword: 'content_middle',
      label: <span className="txt_g">본문 중간<br/>(에디터)</span>,
      className: 'pos_cont',
    },
    {
      keyword: 'content_lower',
      label: <span className="txt_g">본문 하단</span>,
      className: 'pos_cont_bot',
    },
  ];

  const handleClick = (position) => {
    if (checkActivated(position.keyword)) {
      handleClickToggle(position.keyword, false);
    } else {
      handleClickToggle(position.keyword, true);
    }
  };
  return (
    <div className="box_preview">
      <strong className="screen_out">미리보기 목록</strong>
      <ul className="list_box_preview">
        {positions.map(position =>
          <li className={checkActivated(position.keyword) ? 'selected_g' : ''} key={position.keyword}>
            <div className={classnames('box_pos', position.className)} onClick={() => handleClick(position)}>
              {position.label}
            </div>
          </li>
        )}
      </ul>
    </div>
  )
};

export default BoxPreview;